import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import "../styles/blogs.css";

const BACKEND_URL = "https://ddmwrl2uut5q8.cloudfront.net";

const BlogDetails = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    fetch(`${BACKEND_URL}/api/blogs`)
      .then((res) => res.json())
      .then((data) => {
        const found = data.find((b) => b.id === id);
        setBlog(found);
      })
      .catch((err) => {
        console.error("Error fetching blog:", err);
        setBlog(null);
      });
  }, [id]);

  if (!blog) {
    return (
      <div className="blog-details">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="blog-details">
      <h2 className="blog-title">{blog.title}</h2>

      <p className="blog-meta">
        <strong>Author:</strong> {blog.author} &nbsp; | &nbsp;
        <strong>Date:</strong> {blog.date}
      </p>

      <img
        src={
          blog.image
            ? `${BACKEND_URL}${blog.image}`
            : "/images/placeholder-blog.jpg"
        }
        alt={blog.title}
        title="blog"
        className="blog-image"
      />

      <div
        className="blog-content"
        dangerouslySetInnerHTML={{ __html: blog.content }}
      />

      {blog.tags && Array.isArray(blog.tags) && (
        <div className="blog-tags">
          {blog.tags.map((tag, index) => (
            <span key={index} className="blog-tag">
              {tag}
            </span>
          ))}
        </div>
      )}

      <Link to="/blogs" className="back-link">
        ← Back to All Posts
      </Link>
    </div>
  );
};

export default BlogDetails;
